import * as Yup from 'yup'

const MerchantInboundReceiveSchema = Yup.object().shape({
  received_quantity: Yup.number()
    .required('Required')
    .positive('Must be more than 0')
    .max(50, 'Inbound quantity cannot be more than 50'),

  weight: Yup.number()
    .positive('Must be more than 0')
    .required('Required')
})

export default MerchantInboundReceiveSchema